import DoubleSalary from './views/double_salary.c';
export default DoubleSalary;
